export var Color;
(function (Color) {
  Color["CURRENT"] = "currentColor";
  // Core colors
  Color["MAIN"] = "#4B5057";
  Color["LOCKED"] = "#969CA3";
  Color["PHANTOM"] = "#C4C8CC";
  Color["FROZEN"] = "#F7F9FA";
  Color["CLEAR"] = "#FFFFFF";
  Color["PRIMARY"] = "#0E72E5";
  Color["PRIMARY_HOVER"] = "#1A85FF";
  // Separation
  Color["FORM"] = "#DCE1E5";
  Color["DIVIDER"] = "#EBF0F5";
  // Color for table row state
  Color["ROW_HOVER"] = "#89A4BF0D";
  // Service colors
  Color["BRIGHT"] = "#00A2FF";
  Color["BRIGHT_HOVER"] = "#00B2FF";
  Color["BRIGHT_LIGHT"] = "#99C9FF24";
  Color["BRIGHT_LIGHT_HOVER"] = "#80B7FF33";
  Color["SOFT"] = "#7AA0CC";
  Color["SOFT_HOVER"] = "#8AB5E5";
  Color["SOFT_LIGHT"] = "#889EB81A";
  Color["SOFT_LIGHT_HOVER"] = "#7694B833";
  Color["WARNING"] = "#F08000";
  Color["WARNING_HOVER"] = "#FF9000";
  Color["WARNING_LIGHT"] = "#FFB20024";
  Color["WARNING_LIGHT_HOVER"] = "#FF990033";
  Color["DANGER"] = "#E52E59";
  Color["DANGER_HOVER"] = "#FF3363";
  Color["DANGER_LIGHT"] = "#FF99B124";
  Color["DANGER_LIGHT_HOVER"] = "#FF809E33";
  Color["SUCCESS"] = "#479900";
  Color["SUCCESS_HOVER"] = "#53B200";
  Color["SUCCESS_LIGHT"] = "#64DB2C24";
  Color["SUCCESS_LIGHT_HOVER"] = "#55DB1633";
  Color["EXCEPTIONAL"] = "#B255E0";
  Color["EXCEPTIONAL_HOVER"] = "#CD6BFF";
  Color["EXCEPTIONAL_LIGHT"] = "#DE9BFF24";
  Color["EXCEPTIONAL_LIGHT_HOVER"] = "#D582FF33";
  // Brand colors
  Color["BRAND_BLUE"] = "#0059BE";
  Color["BRAND_GREEN"] = "#00E6A0";
  Color["BRAND_BLACK"] = "#1F2833";
  // Deprecated colors
  // Please, don't use these tokens.
  // To pressed state use opacity=0.5 for element.
  Color["PRIMARY_PRESSED"] = "#0C66CC";
  Color["DANGER_PRESSED"] = "#CC2149";
})(Color || (Color = {}));